import APIClient from './index';
import _ from 'lodash';

export const getSEOProducts = params => {
  return new Promise((resolve, reject) => {
    APIClient.get('/Products/for_seo')
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};
